module.exports = __webpack_public_path__ + "app-static/img/idcard-head.abc22c02.png";